import React from 'react';
import LoadingButton from "@mui/lab/LoadingButton";

const Button = ({text, onClick, children, className, disabled, type}) => {
    return (
        <LoadingButton
            onClick={onClick}
            type={type}
            variant="contained"
            disabled={disabled}
            className={`gap-x-3 h-fit ${className}`}
            value={text}
            sx={{
                paddingX: 2,
                paddingY: 1,
                backgroundColor: '#4d4d4d', // Black
                '&:hover': {
                    backgroundColor: '#3d3d3d', // Slightly lighter black for hover
                },
                borderTop: '2px solid #2d2d2d',
                borderRight: '2px solid #2d2d2d',
                borderLeft: '2px solid #2d2d2d',
                borderBottom: '8px solid #2d2d2d',
                '&:active': {
                    borderBottom: '4px solid #2d2d2d',
                },
                color: '#ffffff',
                fontSize: 16,
                textTransform: 'none',
                borderRadius: '12px',
            }}
        >
            {children}
        </LoadingButton>
    );
};

export default Button;
